import RangeSliderContainer from "../../components/bonusUi/rangeSlider";

const RangeSlider = () => {
  return <RangeSliderContainer />;
};

export default RangeSlider;
